/* eslint-disable no-restricted-globals */
import { RESPONSE } from '@factories/vasApiResponseConstants'
import { getTotalUnpaidAmountChallan, getUnpaidChallan } from '@components/MainWidget/common/helper'
import {
  CHALLAN_ENDPOINT,
  CHALLAN_ULIP_FETCH_TIMEOUT,
  PAID,
  UNPAID,
} from '@components/MainWidget/ChallanWidget/challanConstants'
import { API_URL_FACTORY } from '@factories/apiUrlFactory'
import { isValidDate } from '@utils/validDataCheck'
import { fetchWithTimeout } from '@utils/utils'
import { getConfig } from '@configs/envConfig'
import { errorWithStack } from '@utils/logger'

export const ChallanService = async ({ regNo, setChallanAmount, setChallanLength }) => {
  fetch(CHALLAN_ENDPOINT(regNo))
    .then(res => {
      if (!res.ok) {
        throw new Error(`${RESPONSE.ERROR_HTTP} ${res.status}`)
      }
      return res.json()
    })
    .then(data => {
      setChallanAmount(getTotalUnpaidAmountChallan(data.data))
      setChallanLength(getUnpaidChallan(data.data))
    })
    .catch(e => {
      errorWithStack(RESPONSE.CHALLAN_FETCH_FAIL, e)
    })
}

export const getChallanData = async regNo => {
  try {
    const response = await fetch(API_URL_FACTORY.VIEW_CHALLAN_ENDPOINT(regNo))
    const data = await response.json()
    const unpaidChallanData = data?.data?.filter(item => item?.challan_status === UNPAID)
    return unpaidChallanData
  } catch (error) {
    errorWithStack('Error fetching challan link:', error)
  }
}

export const getChallanDataFromUlip = async (regNo, envConfig) => {
  try {
    const apiService = getConfig(envConfig)?.apiService
    const response = await fetchWithTimeout(`${apiService}${API_URL_FACTORY.VIEW_ULIP_ENDPOINT(regNo)}`, {
      timeout: CHALLAN_ULIP_FETCH_TIMEOUT,
    })
    const data = await response.json()
    const unpaidChallans = data?.data
      ?.filter(item => item?.challan_status !== PAID)
      .sort((a, b) => {
        const dateA = isValidDate(a?.violations?.date) ? new Date(a.violations.date) : new Date(0)
        const dateB = isValidDate(b?.violations?.date) ? new Date(b.violations.date) : new Date(0)
        return dateB.getTime() - dateA.getTime()
      })
      ?.slice(0, 10)
    return unpaidChallans || []
  } catch (error) {
    errorWithStack('Error fetching challan data from ULIP:', error)
    return []
  }
}
